<div class="fixed laptop:right-8 z-TOOLTIP w-310 bottom-5">
  <ng-container *ngFor="let toast of toasts; trackBy:trackByToastId;">
    <div [@slideFromRight]
         [ngClass]="[toast.borderColour, toast.backgroundColour]"
         class="w-310 border-1 rounded shadow py-4 px-6 mb-4 transition-all"
         role="alert">
      <div class="flex items-start">
        <div
          [ngClass]="[toast.iconColour]"
          class="text-5 shrink-0">
            <i [class]="toast.icon"></i>
        </div>
        <div class="ml-5">
          <div class="text-3 font-bold">
            {{toast.title}}
          </div>
          <p class="text-3">
            {{toast.description}}
          </p>
          <p *ngIf="toast.errorCode"
             class="mt-2">
            <span class="text-error-500">
              Error code:
            </span>
            <span class="text-error-500 font-medium">
              {{toast.errorCode}}
            </span>
          </p>
        </div>
        <button *ngIf="toast.shouldShowClose"
                (click)="close(toast)"
                class="ml-auto"
                type="button">
          <div class="h-11 w-11 shrink-0">
            <i class="fa-kit fa-talos-small-cross"></i>
          </div>
        </button>

      </div>
    </div>
  </ng-container>
</div>